export default __webpack_public_path__ + "static/browser_diagram_page-load-timeline-e0e5cabefa56059c27358c85a0646e90.webp";